import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {NavLink, Redirect, Switch} from 'react-router-dom';
import styled from 'react-emotion';
import {connect} from 'react-redux';

import Page from '../layout/Page';
import AllAuditsTable from './AllAuditsTable';
import {ROLES} from '../security/RequiresRole';
import AuthorizedRoute from '../security/AuthorizedRoute';

const PageWrapper = styled(Page.Basic)`
  .ui.menu .item {
    height: 42px;

    > .label.request-badge {
      background: #dfae38;
    }
  }
`;

class IndexScreen extends Component {
  render() {
    return (
      <PageWrapper
        title="Search Listing"
        secondary={
          <Menu secondary pointing>
            <Menu.Item as={NavLink} to="/manage/searches" exact>
              All Searches
            </Menu.Item>
          </Menu>
        }
      >
        <Switch>
          <AuthorizedRoute
            exact
            path="/manage/searches"
            component={AllAuditsTable}
            roles={[ROLES.SYSTEM_ADMIN, ROLES.MM_ADMIN, ROLES.CUSTOMER_ADMIN]}
          />
          <Redirect to="/manage/searches" />
        </Switch>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({identity}) => {
  return {
    user: identity.user,
  };
};

export default connect(mapStateToProps)(IndexScreen);
